var _style, _polygon, _circle, _path, _circle2, _rect, _path2, _circle3, _rect2, _path3, _circle4, _rect3, _path4, _circle5, _rect4, _path5, _circle6, _rect5, _circle7, _path6, _path7, _circle8, _circle9, _circle0, _circle1, _polygon2, _polygon3, _polygon4, _path8, _g, _path9, _path0, _defs, _g2, _path1, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHappy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a780dc9c-2107-4fd6-8fec-765248a5097a",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 887.8 772.8",
    style: {
      enableBackground: "new 0 0 887.8 772.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E6E6E6;}\n\t.st1{fill:#FF6584;}\n\t.st2{fill:#3F3D56;}\n\t.st3{fill:#6C63FF;}\n\t.st4{fill:#FFFFFF;}\n\t.st5{fill:#848484;}\n\t.st6{fill:#DDDDDD;}\n\t.st7{display:none;}\n\t.st8{display:inline;}\n\t.st9{display:inline;clip-path:url(#SVGID_2_);}\n\t.st10{fill:#FCE37C;}\n\t.st11{fill:#564EA8;}\n\t.st12{fill:#F27670;}\n\t.st13{display:inline;clip-path:url(#SVGID_2_);fill:none;}\n\t.st14{opacity:0.3;fill:#757575;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "happy_music") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "887.8,763.2 252.3,772.8 0,728.1 393.8,728.1 "
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 731.8,
    cy: 101.7,
    r: 101.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M179.8,733.4c0,0,1.5-31.2,32-27.5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 171.2,
    cy: 688.5,
    r: 15.3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 168.7,
    y: 714.2,
    className: "st2",
    width: 4.3,
    height: 30.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M682.3,738.8c0,0,1.5-31.2,32-27.5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 673.7,
    cy: 693.8,
    r: 15.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 671.2,
    y: 719.5,
    className: "st2",
    width: 4.3,
    height: 30.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M755.7,744.1c0,0,1.5-31.2,32-27.5"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 747.1,
    cy: 699.2,
    r: 15.3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 744.6,
    y: 724.9,
    className: "st2",
    width: 4.3,
    height: 30.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M300.1,718.5c0,0,1.5-31.2,32-27.5"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 291.5,
    cy: 673.6,
    r: 15.3
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 289,
    y: 699.3,
    className: "st2",
    width: 4.3,
    height: 30.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M73.4,723.9c0,0,1.5-31.2,32-27.5"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 64.8,
    cy: 678.9,
    r: 15.3
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 62.3,
    y: 704.6,
    className: "st2",
    width: 4.3,
    height: 30.1
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 442.3,
    cy: 503.5,
    r: 166.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M337.6,470.7c15.6-18.6,43.3-21.1,62-5.6c2,1.7,3.9,3.5,5.6,5.6c19.5-18.6,20.2-49.6,1.6-69.1 c-18.6-19.5-49.6-20.2-69.1-1.6c-19.5,18.6-20.2,49.6-1.6,69.1C336.5,469.6,337.1,470.1,337.6,470.7z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M469.6,470.7c15.6-18.6,43.3-21.1,62-5.6c2,1.7,3.9,3.5,5.6,5.6c19.5-18.6,20.2-49.6,1.6-69.1 c-18.6-19.5-49.6-20.2-69.1-1.6s-20.2,49.6-1.6,69.1C468.5,469.6,469.1,470.1,469.6,470.7z"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 354.7,
    cy: 418.7,
    r: 16.8
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 486.7,
    cy: 418.7,
    r: 16.8
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 322.5,
    cy: 498.9,
    r: 19.6
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 547.4,
    cy: 498.9,
    r: 19.6
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "434.9,467.1 420.3,530.7 444.7,506.2 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "510.3,750.4 493.7,736.4 494,750.4 488.9,750.4 488.5,735.6 466,750.4 456.6,750.4 488.3,729.5  487.1,685.7 486.1,652.7 491.3,652.5 492.2,685.7 493.5,729.5 518.3,750.4 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "432.1,750.4 415.4,736.4 415.8,750.4 410.7,750.4 410.2,735.6 387.8,750.4 378.3,750.4 410.1,729.5  408.8,685.7 407.9,652.7 413.1,652.5 414,685.7 415.2,729.5 440.1,750.4 "
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M444.7,325c-4.6,0-8.6,3.5-11.3,9c-2.4-8.2-7.4-13.9-13.2-13.9c-0.4,0-0.8,0.1-1.2,0.2 c-2.2-8.7-7.4-14.9-13.5-14.9c-8.1,0-14.7,10.9-14.7,24.4s6.6,24.4,14.7,24.4c0.4,0,0.8-0.1,1.2-0.2c2.2,8.7,7.4,14.9,13.5,14.9 c4.6,0,8.6-3.5,11.3-9c2.4,8.2,7.4,13.9,13.2,13.9c8.1,0,14.7-10.9,14.7-24.4S452.8,325,444.7,325z"
  })), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M606,474.3c-1.2-6.4-1.6-8.3-2.1-10.3c-0.6-2.1-1.1-3.8-1.4-4.9c-7.6,12.1-15.3,24.5-22.9,37.1 c-3.8,6.3-7.5,12.6-11.2,18.9l16.2,11.9c3.3-9.7,13.2-28.8,22.6-46.1C606.7,478.2,606.3,476,606,474.3z"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M279.1,472.9c-1.9,5.9-2.4,11.9-2.8,18c6.9,13.6,13.6,27.7,16.5,36.1l13.5-10.7 C306.4,516.3,292.5,493.5,279.1,472.9z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M315.4,508.9c-21.5,4.1-34.7,43.5-27.1,64.6c2.3,6.4,8,13.5,19.5,27.8c8.4,10.4,16.1,18.9,19.2,22 c46.2,47,114.1,47.4,114.1,47.4s52.1,0.3,96.6-31.1c15.7-11.1,29.8-25.9,36.6-35.1c6.4-8.8,13-20.3,13-20.3c1.7-3,3.2-5.7,3.6-6.5 c6.3-12.3,2.8-57.1-23.4-64.5c-40.8-11.5-80.3-28.8-120.2-28.8C403.2,484.4,361.9,500,315.4,508.9z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M315.4,508.9c-29.4,5.6-43.9,39.8-27.1,64.6c38.1,55.9,92.4,97.2,152.8,97.2c58.8,0,111.9-39.2,149.8-93 c16.7-23.6,4.4-56.7-23.4-64.5c-40.8-11.5-80.3-28.8-120.2-28.8C403.2,484.4,361.9,500,315.4,508.9z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_",
    className: "st8"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M348,559.9c0,17.3-6.3,31.3-14.1,31.3c-7.8,0-14.1-14-14.1-31.3c0-17.3,6.3-31.3,14.1-31.3 C341.7,528.7,348,542.7,348,559.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M348,622.5c0,17.3-6.3,31.3-14.1,31.3c-7.8,0-14.1-14-14.1-31.3s6.3-31.3,14.1-31.3 C341.7,591.2,348,605.2,348,622.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M321.8,559.1c12.2,12.2,17.7,26.6,12.1,32.1c-5.5,5.5-19.9,0.1-32.1-12.2c-12.2-12.2-17.7-26.6-12.2-32.1 C295.2,541.5,309.6,546.9,321.8,559.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M366,603.4c12.2,12.2,17.7,26.6,12.2,32.1c-5.5,5.5-19.9,0.1-32.1-12.2c-12.2-12.2-17.7-26.6-12.2-32.1 C339.4,585.7,353.8,591.2,366,603.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M302.7,577.1c17.3,0,31.3,6.3,31.3,14.1c0,7.8-14,14.1-31.3,14.1c-17.3,0-31.3-6.3-31.3-14.1 C271.4,583.4,285.4,577.1,302.7,577.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M365.2,577.1c17.3,0,31.3,6.3,31.3,14.1c0,7.8-14,14.1-31.3,14.1c-17.3,0-31.3-6.3-31.3-14.1 C333.9,583.4,347.9,577.1,365.2,577.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M301.9,603.4c12.2-12.2,26.6-17.7,32.1-12.2c5.5,5.5,0.1,19.9-12.1,32.1c-12.2,12.2-26.6,17.7-32.1,12.2 C284.2,630,289.6,615.6,301.9,603.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M346.1,559.1c12.2-12.2,26.6-17.7,32.1-12.2c5.5,5.5,0.1,19.9-12.2,32.1c-12.2,12.2-26.6,17.7-32.1,12.2 C328.4,585.7,333.9,571.4,346.1,559.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M345.9,591.2c0,7.8-6.3,14.1-14.1,14.1c-7.8,0-14.1-6.3-14.1-14.1c0-7.8,6.3-14.1,14.1-14.1 C339.6,577.1,345.9,583.4,345.9,591.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M597.1,490.5c-3.1,20.6-13.2,36.1-22.4,34.7c-9.3-1.4-14.2-19.2-11.1-39.8c3.1-20.6,13.1-36.1,22.4-34.7 C595.2,452.1,600.2,469.9,597.1,490.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M585.8,564.9c-3.1,20.6-13.1,36.1-22.4,34.7c-9.3-1.4-14.2-19.2-11.1-39.8c3.1-20.6,13.1-36.1,22.4-34.7 C584,526.6,588.9,544.4,585.8,564.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M566,484.8c12.3,16.7,16.2,34.8,8.7,40.4c-7.5,5.6-23.7-3.5-36-20.2c-12.3-16.7-16.2-34.8-8.7-40.4 C537.6,459,553.7,468.1,566,484.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M610.7,545.4c12.3,16.7,16.2,34.8,8.7,40.4c-7.6,5.6-23.7-3.5-36-20.2c-12.3-16.7-16.2-34.8-8.7-40.4 C582.2,519.6,598.3,528.7,610.7,545.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M540,502.8c20.6,3.1,36.1,13.2,34.7,22.4c-1.4,9.3-19.2,14.3-39.8,11.1c-20.6-3.1-36.1-13.1-34.7-22.4 C501.7,504.6,519.5,499.7,540,502.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M614.5,514c20.6,3.1,36.1,13.1,34.7,22.4c-1.4,9.3-19.2,14.2-39.8,11.1c-20.6-3.1-36.1-13.1-34.7-22.4 C576.1,515.9,593.9,510.9,614.5,514z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M534.3,533.9c16.7-12.3,34.8-16.2,40.4-8.7c5.6,7.5-3.5,23.7-20.2,36c-16.7,12.3-34.8,16.2-40.4,8.7 C508.5,562.3,517.6,546.2,534.3,533.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M635.3,480.5c-1.7-2.3-4.7-3.6-8.4-3.8c0,0.1,0,0.1,0,0.2c-0.9,4.7-6.7,4.1-8.5,0.7 c-0.7,0.2-1.4,0.4-2.1,0.6c0,0.1,0,0.2,0,0.3c1,5.7-7.3,8.2-8.9,3.1c-4.1,2-8.3,4.5-12.4,7.5c-16.7,12.3-25.8,28.4-20.2,36 c5.6,7.5,23.6,3.7,40.4-8.7C631.8,504.2,640.9,488.1,635.3,480.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M588.9,527.3c-1.4,9.3-10.1,15.6-19.3,14.2c-9.3-1.4-15.6-10-14.2-19.3c1.4-9.3,10.1-15.6,19.3-14.2 C583.9,509.4,590.3,518.1,588.9,527.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M484.6,614.1c-1.9,12.5-8,21.9-13.6,21c-5.6-0.9-8.6-11.6-6.7-24.1c1.9-12.5,8-21.9,13.6-21 C483.5,590.8,486.5,601.6,484.6,614.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M477.8,659.2c-1.9,12.5-8,21.9-13.6,21c-5.6-0.9-8.6-11.6-6.7-24.1c1.9-12.5,8-21.9,13.6-21 C476.6,636,479.7,646.7,477.8,659.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M465.8,610.6c7.5,10.1,9.8,21.1,5.3,24.5c-4.6,3.4-14.3-2.1-21.8-12.3c-7.5-10.1-9.8-21.1-5.3-24.5 C448.5,595,458.3,600.5,465.8,610.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M492.8,647.4c7.5,10.1,9.8,21.1,5.3,24.5c-4.6,3.4-14.3-2.1-21.8-12.3c-7.5-10.1-9.8-21.1-5.3-24.5 C475.6,631.7,485.4,637.2,492.8,647.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M450,621.5c12.5,1.9,21.9,8,21,13.6c-0.8,5.6-11.6,8.6-24.1,6.7c-12.5-1.9-21.9-8-21-13.6 C426.8,622.7,437.5,619.6,450,621.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M495.1,628.4c12.5,1.9,21.9,8,21,13.6c-0.8,5.6-11.6,8.6-24.1,6.7c-12.5-1.9-21.9-8-21-13.6 C471.9,629.5,482.7,626.5,495.1,628.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M446.6,640.4c10.1-7.5,21.1-9.8,24.5-5.3c3.4,4.6-2.1,14.3-12.3,21.8c-10.1,7.5-21.1,9.8-24.5,5.3 C430.9,657.6,436.4,647.8,446.6,640.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M483.3,613.3c10.1-7.5,21.1-9.8,24.5-5.3c3.4,4.6-2.1,14.3-12.3,21.8c-10.1,7.5-21.1,9.8-24.5,5.3 C467.7,630.5,473.1,620.8,483.3,613.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M479.6,636.4c-0.9,5.6-6.1,9.5-11.7,8.6c-5.6-0.9-9.5-6.1-8.6-11.7c0.9-5.6,6.1-9.5,11.7-8.6 C476.6,625.6,480.5,630.8,479.6,636.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M406.9,464.7c-1.9,12.5-8,21.9-13.6,21c-5.6-0.8-8.6-11.6-6.7-24.1c1.9-12.5,8-21.9,13.6-21 C405.7,441.4,408.7,452.2,406.9,464.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M400,509.8c-1.9,12.5-8,21.9-13.6,21c-5.6-0.8-8.6-11.6-6.7-24.1c1.9-12.5,8-21.9,13.6-21 C398.9,486.5,401.9,497.3,400,509.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M388,461.2c7.5,10.1,9.8,21.1,5.3,24.5c-4.6,3.4-14.3-2.1-21.8-12.3c-7.5-10.1-9.8-21.1-5.3-24.5 C370.8,445.6,380.6,451.1,388,461.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M415.1,498c7.5,10.1,9.8,21.1,5.3,24.5c-4.6,3.4-14.3-2.1-21.8-12.3c-7.5-10.1-9.8-21.1-5.3-24.5 C397.9,482.3,407.6,487.8,415.1,498z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M372.3,472.1c12.5,1.9,21.9,8,21,13.6c-0.8,5.6-11.6,8.6-24.1,6.8c-12.5-1.9-21.9-8-21-13.6 C349,473.2,359.8,470.2,372.3,472.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M417.4,478.9c12.5,1.9,21.9,8,21,13.6c-0.8,5.6-11.6,8.6-24.1,6.7c-12.5-1.9-21.9-8-21-13.6 C394.1,480.1,404.9,477.1,417.4,478.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M368.8,490.9c10.1-7.5,21.1-9.8,24.5-5.3c3.4,4.6-2.1,14.3-12.3,21.8c-10.1,7.5-21.1,9.8-24.5,5.3 C353.2,508.2,358.7,498.4,368.8,490.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M405.6,463.9c10.1-7.5,21.1-9.8,24.5-5.3c3.4,4.6-2.1,14.3-12.3,21.8c-10.1,7.5-21.1,9.8-24.5,5.3 C389.9,481.1,395.4,471.4,405.6,463.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M401.9,487c-0.9,5.6-6.1,9.5-11.7,8.6c-5.6-0.9-9.5-6.1-8.6-11.7c0.8-5.6,6.1-9.5,11.7-8.6 C398.9,476.1,402.8,481.4,401.9,487z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M469,534.6c-1.6,10.5-6.7,18.4-11.4,17.7c-4.7-0.7-7.3-9.8-5.7-20.3c1.6-10.5,6.7-18.4,11.4-17.7 C468,515,470.5,524.1,469,534.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M463.2,572.6c-1.6,10.5-6.7,18.4-11.4,17.7c-4.7-0.7-7.3-9.8-5.7-20.3c1.6-10.5,6.7-18.4,11.4-17.7 C462.2,553,464.8,562.1,463.2,572.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M453.1,531.7c6.3,8.5,8.3,17.8,4.4,20.6c-3.8,2.8-12.1-1.8-18.4-10.3c-6.3-8.6-8.3-17.8-4.4-20.6 C438.5,518.5,446.8,523.1,453.1,531.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M475.9,562.6c6.3,8.5,8.3,17.8,4.4,20.6c-3.8,2.8-12.1-1.8-18.4-10.3c-6.3-8.6-8.3-17.8-4.4-20.6 C461.4,549.4,469.6,554.1,475.9,562.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M439.8,540.8c10.5,1.6,18.4,6.7,17.7,11.4c-0.7,4.7-9.8,7.3-20.3,5.7c-10.5-1.6-18.4-6.7-17.7-11.4 C420.2,541.8,429.3,539.2,439.8,540.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M477.8,546.6c10.5,1.6,18.4,6.7,17.7,11.4c-0.7,4.7-9.8,7.3-20.3,5.7c-10.5-1.6-18.4-6.7-17.7-11.4 C458.2,547.5,467.3,545,477.8,546.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M436.9,556.7c8.6-6.3,17.8-8.3,20.6-4.4c2.8,3.8-1.8,12.1-10.3,18.4c-8.6,6.3-17.8,8.3-20.6,4.4 C423.7,571.2,428.3,563,436.9,556.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M467.8,533.9c8.6-6.3,17.8-8.3,20.6-4.4c2.8,3.9-1.8,12.1-10.3,18.4c-8.5,6.3-17.8,8.3-20.6,4.4 C454.7,548.4,459.3,540.2,467.8,533.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M464.8,553.4c-0.7,4.7-5.1,8-9.9,7.3c-4.7-0.7-8-5.1-7.3-9.9c0.7-4.7,5.1-8,9.9-7.3 C462.2,544.2,465.5,548.6,464.8,553.4z"
  })))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M567.5,513.2c-40.8-11.5-80.3-28.8-120.2-28.8"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M370.4,542.4c-6,0.6,45.7-31.3,148.9,3.1C519.3,545.4,451.7,534.4,370.4,542.4z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M370.4,588.2c-6,0.7,37.2-36.5,148.9,3.1C519.3,591.2,458.3,577.9,370.4,588.2z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M567.5,513.2c-40.8-11.5-80.3-28.8-120.2-28.8c-2.3,0-4.5,0.2-6.7,0.3c-17.8,62-16.7,124,3.1,185.9 c11.5-0.9,54.7-5.1,90.5-28.7c2.3-1.5,23.4-15.5,36.6-32.8c2.1-2.7,7.1-9.6,12.6-18.5c3.5-5.7,6.6-11.3,7.4-12.9 C597.6,564,595.2,521,567.5,513.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappy);
export default __webpack_public_path__ + "static/media/happy.ac21f6801a0c93fdc784e944b65d8c5f.svg";
export { ForwardRef as ReactComponent };